var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 18,
    rx: 4.5,
    fill: "black",
    fillOpacity: 0.2,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 4C11 3.44772 10.5523 3 10 3C9.44772 3 9 3.44772 9 4L11 4ZM9.29289 15.7071C9.68342 16.0976 10.3166 16.0976 10.7071 15.7071L17.0711 9.34315C17.4616 8.95262 17.4616 8.31946 17.0711 7.92893C16.6805 7.53841 16.0474 7.53841 15.6569 7.92893L10 13.5858L4.34315 7.92893C3.95262 7.53841 3.31946 7.53841 2.92893 7.92893C2.53841 8.31946 2.53841 8.95262 2.92893 9.34315L9.29289 15.7071ZM9 4L9 15L11 15L11 4L9 4Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.aee266b5e72fde61b4e0c10d20344468.svg";
export { ForwardRef as ReactComponent };